import { message } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { roleandpermissions } from "../../services";
import { showCustomMessage } from "../../pages/roles-and-permissions/constant";
import moment from "moment";
import { useB2BContext } from "../../context/ContextB2B";
import { EditOutlined, MailOutlined } from "@ant-design/icons";
import "./datatable.scss";
import { AppTable } from "../common";

type Props = {
  rolesData: any;
  loader: boolean;
  onEdit: (addEditModal: any) => void;
};

export default function DataTableRolesPermission({
  rolesData,
  loader,
  onEdit,
}: Props): JSX.Element {
  const { getUserByID } = useB2BContext();

  const resendMail = (data: any) => {
    roleandpermissions
      .addUserRoles({
        full_name: data?.full_name,
        email: data?.email,
        username: data?.email,
        user_type: data?.user_type,
        resend: true,
      })
      .then((res: any) => {
        showCustomMessage("Resend", true);
      })
      .catch((err: any) => {
        message.error(err.message || "Something went wrong");
      });
  };

  const columns: ColumnsType<any> = [
    {
      title: "Name",
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: "Role",
      dataIndex: "user_type",
      key: "user_type",

      render(value) {
        return (
          <div style={{ textTransform: "capitalize" }}>
            {getUserByID?.user_type === "Company_member"
              ? (getUserByID?.roles?.[0])
              : (value?.replace(/_/g, " "))}
          </div>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Joined On",
      dataIndex: "createdAt",
      key: "createdAt",
      render(value, record) {
        return (
          <div>
            {record?.isFirst
              ? "Pending"
              : new Date(value)
                  .toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })
                  .replace(/,/g, "")}
          </div>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    {
      title: "Action",
      dataIndex: "name",
      key: "name",
      render(_, record) {
        return (
          <div>
            {record?.isFirst ? (
              <button
                className="table_pill_btn table_pill_btn--view"
                onClick={() => resendMail(record)}
              >
                <MailOutlined />
                Resend
              </button>
            ) : (
              <button
                className="table_pill_btn table_pill_btn--view"
                onClick={() => onEdit(record)}
              >
                <EditOutlined />
                Edit
              </button>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="rolesTable">
      <AppTable
        rowKey={rolesData?._id}
        loading={loader}
        columns={columns}
        dataSource={rolesData || []}
      />
    </div>
  );
}
